import { Drawer } from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';

import { useCartDrawer } from '../providers/cartDrawer/cartDrawerProvider';

type CartDrawerProps = PropsWithChildren<{
  fitScreen?: boolean;
  isMobile: boolean;
}>;

export const CartDrawer = ({
  fitScreen,
  isMobile,
  children,
}: CartDrawerProps) => {
  const { close, isOpen } = useCartDrawer();
  return (
    <Drawer
      background="grays-ultralight"
      data-testid="cart-drawer"
      fitScreen={fitScreen}
      onRequestClose={close}
      open={isOpen}
      overlayClose
      placement="right"
      width={isMobile ? '95vw' : '540px'}
    >
      {children}
    </Drawer>
  );
};
